import { gql } from '@apollo/client';

export const CREATE_NEW_CONTACT = gql`
	mutation CreateNewContact($input: CreateContactInput!) {
		createNewContact(input: $input) {
			id
			name
			submitted_at
		}
	}
`;
